import { helper } from '@ember/component/helper';
import { ActionType } from 'cio/models/action';
import { JourneyMetricsMeasure } from 'cio/utils/journey-metrics';
import { Measure } from 'cio/utils/metrics/common';
import { findDenominator, MeasureType } from 'cio/utils/metrics/measure';

export function measureDenominator([measure, measureType, actionType]: [
  string,
  MeasureType.DeliveryMetrics,
  ActionType,
]): Measure | null;
export function measureDenominator([measure, measureType, actionType]: [
  string,
  MeasureType.JourneyMetrics,
  null,
]): JourneyMetricsMeasure | null;
export function measureDenominator([measure, measureType, actionType]: [any, any, any]): string | null {
  return findDenominator(measure, measureType, actionType);
}

export default helper(measureDenominator);
